<script setup lang="ts">
import type { Column } from "@/models/Column";
import type { DeleteFilter } from "@/pages/CaseSearch.vue";

defineProps<{ column: Column; values: string | number | string[] | number[] }>();
defineEmits({ deleteFilter: null as unknown as DeleteFilter });
</script>
<template>
  <div
    v-for="(value, idx) in Array.isArray(values) ? values : [values]"
    :key="`${value}-${idx}`"
    role="listitem"
    class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-rounded-md tw-border tw-bg-gray-200 tw-px-2 tw-py-1"
    :tabindex="0"
    :aria-label="`${column.displayName}: ${value}`"
  >
    <span class="tw-min-w-max">{{ column.displayName }}: {{ value }}</span>
    <button
      type="button"
      aria-label="Delete Filter"
      class="tw-grid tw-aspect-square tw-w-6 tw-place-items-center tw-rounded-md tw-p-1 hover:tw-bg-white"
      @click="$emit('deleteFilter', column, idx)"
    >
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>
</template>
